import { useState } from "react";
import { Fade } from "react-reveal";

export default function KaryaTerbaruCard(props){
    const [onHover, setOnHover] = useState();

    function opacityHalf(e, value) {
        setOnHover(value);
        e.target.style.opacity = "0.3";
    }
    function opacityFull(e, value) {
        setOnHover();
        e.target.style.opacity = "1";
    }

    return(
        <Fade bottom>
            <span className='d-flex align-items-center justify-content-center gap-3'>
                <span>
                    2<br/>0<br/>2<br/>{props.tahun}<br/>
                </span>
                <div className='position-relative'>
                    <p className={(onHover === props.value ? '' : 'd-none') + ' position-absolute top-50 start-50 translate-middle text-center'}>{props.textTop} <br/> {props.textDown}</p>
                    <img onMouseEnter={(e)=>opacityHalf(e,props.value)} onMouseLeave={(e)=>opacityFull(e,props.value)} id={props.valueIntext} src={"./Project/"+props.image} alt="" />
                </div>
            </span>
        </Fade>
    )
}